import { RequestDetailsForApproval } from "@api";
import { CardWrapper } from "@components";
import { Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { RequestsDetailTable } from "./requestsDetailsTable";
import { TextareaAutosize } from "@material-ui/core";
import { Form } from "@components";
import { Field } from "../../../../components/form/fields/field";

const useStyles = makeStyles((theme: Theme) => ({
  underlined: {
    textDecoration: "underline",
  },
  rightBox: {
    borderBottom: "1px solid #cecece",
    borderLeft: "1px solid #cecece",
    padding: theme.spacing(3),
  },
  leftBox: {
    borderBottom: "1px solid #cecece",
    padding: theme.spacing(3),
  },
  bottomBox: {
    padding: theme.spacing(3),
  },
}));

interface Props {
  request: RequestDetailsForApproval;
  reSubmitRequestData?: any;
  isResubmitForm?: boolean;
  financeFormSecuritiesForResubmit?: any;
}

export const RequestDetails: React.FC<Props> = ({
  request,
  reSubmitRequestData,
  financeFormSecuritiesForResubmit,
}) => {
  const classes = useStyles();

  const [justification, setJustification] = useState(
    request.justification || ""
  );

  const onChange = (e: any) => {
    setJustification(e.target.value);
  };

  const justificationTextbox = request.isSendBack ? (
    <Form>
      <Field label="" size={12}>
        <TextareaAutosize
          onChange={onChange}
          rowsMin={3}
          placeholder="Enter justification here."
          value={justification || ""}
        />
      </Field>
    </Form>
  ) : null;

  const [updatedRequestDataState, setUpdatedRequestDataState] = useState(
    request.accessRequests || []
  );
  const getUpdatedAccessRequests = (data: any) => {
    setUpdatedRequestDataState(data);
  };

  useEffect(() => {
    let accessRequestJusifications: any[] = [];
    updatedRequestDataState.forEach((d: any) => {
      accessRequestJusifications = [
        ...accessRequestJusifications,
        {
          id: d.id,
          accessDetailJustification: d.accessJustification,
        },
      ];
    });

    reSubmitRequestData({
      id: request.id,
      isSendBack: true,
      justification: justification,
      accessRequestJustification: accessRequestJusifications,
    });
  }, [updatedRequestDataState, justification]);

  const revokeTypeValue = request?.revokeType
    ? ` - ${request.revokeType}`
    : null;
  return (
    <CardWrapper title="Request Details">
      <Grid container>
        <Grid item container xs={6} className={classes.leftBox}>
          <Grid container item spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.underlined}>
                Basic Information
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Type of Action:</b>
                </span>{" "}
                {request?.requestType}
                {revokeTypeValue}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Effective Date of this Action:</b>
                </span>{" "}
                {request?.effectiveDate}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Date Requested:</b>
                </span>{" "}
                {request?.dateAdded}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>System Category:</b>
                </span>{" "}
                {request?.category}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Reference No:</b>
                </span>{" "}
                {request?.referenceNumber}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Advanced Request:</b>
                </span>{" "}
                {request?.isAdvance ? "Yes" : "No"}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Start Date:</b>
                </span>{" "}
                {request?.advanceDate}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>RF No.:</b>
                </span>{" "}
                {request?.serviceTicketNumber}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">
                <span>
                  <b>Justification:</b>
                </span>{" "}
                {request.isSendBack
                  ? justificationTextbox
                  : request?.justification}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={6}
          className={classes.rightBox}
          alignItems="flex-start"
        >
          <Grid container item spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.underlined}>
                User Information
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Name:</b>
                </span>{" "}
                {request?.userName}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Email:</b>
                </span>{" "}
                {request?.userEmail}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Employee ID:</b>
                </span>{" "}
                {request?.userID}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">
                <span>
                  <b>Note:</b>
                </span>{" "}
                {""}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} className={classes.bottomBox}>
          <Grid item xs={12}>
            <Typography variant="body1">System Access Required</Typography>
          </Grid>
          <Grid item xs={12}>
            <RequestsDetailTable
              user={request.userName}
              accessRequests={request.accessRequests}
              status={request.status}
              isSendBack={request.isSendBack}
              updatedAccessRequests={getUpdatedAccessRequests}
              financeFormSecuritiesForResubmit={
                financeFormSecuritiesForResubmit
              }
            ></RequestsDetailTable>
          </Grid>
        </Grid>
      </Grid>
    </CardWrapper>
  );
};
